import { useEffect, useState } from "react";
import { Box, Button, Grid, Card } from "@mui/material";
import { getDateFormat } from "../helper";

function ItemBox({
  imagesList,
  isEditN,
  onSaveSort,
  onCancelSort,
  onClickEdit,
  onClickDelete,
}) {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData([...imagesList]);
  }, [imagesList]);

  const setSlotItem = (id) => {
    const find = data.find(f => f.photoid === id && f.newslot);
    if (find) { // delete
      const slot = find.newslot;

      let list = [];
      data.forEach((f) => {
        if (f.photoid === id) {
          f.newslot = 0;
        } else if (f.newslot > slot && f.newslot) {
          f.newslot = f.newslot - 1;
        }
        list.push({ ...f });
      })
      setData(list);

    } else { // set number
      const maxValue = Math.max(...data.map((m) => (m.newslot || 0)));
      
      let list = [];
      data.forEach((f) => {
        if (f.photoid === id) {
          f.newslot = maxValue + 1;
        }
        list.push({ ...f });
      })
      setData(list);
    }
  }

  const onSetSort = () => {
    setData([...data.sort((a, b) => (a.newslot||999) - (b.newslot || 999))]);
  }

  return (<Box>
    {isEditN && (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <p>กรุณาเลือกรายการเพื่อจัดลำดับการแสดงผล</p>
        <Box sx={{ display: 'flex' }}>
          <Button
            onClick={() => onSetSort()}
            style={{ 
              color: '#7BBA81',
              fontFamily: 'KIT65P',
              fontSize: '1.5rem',
              padding: '2px 10px',
              width: 100,
              background: 'white',
              border: '1px solid #7BBA81',
              borderRadius: '16px',
              marginRight: 10,
            }}
          >จัดเรียง</Button>
          <Button
            onClick={() => onSaveSort(data)}
            style={{ 
              color: 'white',
              fontFamily: 'KIT65P',
              fontSize: '1.5rem',
              padding: '2px 10px',
              width: 100,
              background: '#7BBA81',
              borderRadius: '16px',
              marginRight: 10,
            }}
          >บันทึก</Button>
          <Button 
            onClick={onCancelSort} 
            style={{ 
              color: 'white',
              fontFamily: 'KIT65P',
              fontSize: '1.5rem',
              padding: '2px 10px',
              width: 100,
              background: 'rgba(255, 0, 0, 0.7)',
              borderRadius: '16px'
            }}
          >ยกเลิก</Button>
        </Box>
      </Box>
    )}
    <Grid container spacing={3} sx={{ marginBottom: '30px' }}>
      {data.map((m, i) => (
        <Grid item key={i} xs={12} sm={6} md={6} lg={3} xl={3}>
          <Card sx={{ 
            height: '100%',
            position: 'relative',
            border: isEditN && m.newslot ? '2px solid #5F966C' : '',
            cursor: isEditN ? 'pointer' : ''
          }}
            onClick={() => setSlotItem(m.photoid)}
            id={m.photoid}
          >
            {m.mediatype === 'video' ? (
              <video autoPlay muted loop
                style={{ width: '100%', maxHeight: 200 }}
                src={m.videourl}
              >
              </video>
            ) : (
              <img src={m.imgurl} style={{ width: '100%', height: 'auto', maxHeight: 200 }} />
            )}
            
            <Box sx={{ py: 1, px: 3 }} className="mb-item" style={isEditN ? { marginBottom: '10px' } : {}}>
              <Box sx={{ display: 'flex' }}>
                <p style={{ width: '25%' }}>เริ่มต้น</p>
                <p>{getDateFormat(m.validbegin)}</p>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <p style={{ width: '25%' }}>สิ้นสุด</p>
                <p>{getDateFormat(m.validend)}</p>
              </Box>
            </Box>

            {isEditN && (
              <>
                <Box sx={{ position: 'absolute', top: 14, right: 14 }}>
                  {!m.newslot ? (
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      background: 'white',
                      // border: '1px solid black',
                      border: '3px solid #5F966C',
                      borderRadius: '50%',
                      width: 50,
                      height: 50
                    }} />
                  ) : (
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      color: 'white',
                      // border: '1px solid black',
                      background: '#5F966C',
                      borderRadius: '50%',
                      width: 50,
                      height: 50
                    }}>
                      <h5>{m.newslot}</h5>
                    </Box>
                  )}
                </Box>
              </>
            )}

            {!isEditN && (
              <Box sx={{ position: 'absolute', bottom: 0, right: 0 }}>
                <Box sx={{ display: 'flex' }}>
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    color: 'white',
                    background: 'rgba(95, 150, 108, 0.7)',
                    padding: '5px 14px',
                    minWidth: 70,
                    cursor: 'pointer'
                  }}
                    onClick={() => onClickEdit(m)}
                  >
                    <img src="/images/reset2.svg" style={{ height: 18, width: 'auto', marginRight: 7 }} />
                    <p>แก้ไข</p>
                  </Box>
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    color: 'white',
                    background: 'rgba(255, 0, 0, 0.7)',
                    padding: '5px 14px',
                    minWidth: 70,
                    cursor: 'pointer'
                  }}
                    onClick={() => onClickDelete(m)}
                  >
                    <img src="/images/delete.png" style={{ height: 18, width: 'auto', marginRight: 7 }} />
                    <p>ลบ</p>
                  </Box>
                </Box>
              </Box>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>)
}

export default ItemBox;
